export default {
  categoryDescriptionRules: [
    (v) =>
      (!!v && v.length <= 50) ||
      "Description is required and must be less than 50 characters",
  ],
  descriptionRules: [(v) => (!!v && v.length <= 256) || "Description is required and must be less than 256 characters"],
  quantityRules: [
    (v) => !!v || "Quantity is required",
    (v) => (new RegExp(/^[1-9]{1}[0-9]{0,5}$/)).test(v) || "Quantity must be a whole number"
  ],
  weightRules: [
    (v) => !!v || "Weight is required",
    (v) => (new RegExp(/^[1-9]{1}[0-9]{0,5}$/)).test(v) || "Weight must be a whole number"
  ],
  valueRules: [
    (v) => !!v || "Value is required",
    (v) => (new RegExp(/^[1-9]{1}[0-9]{0,6}$/)).test(v) || "Value must be a whole number"
  ],
  nameRules: [
    (v) => !!v || "Name is required",
    (v) => v.length <= 14 || "Name must be at most 14 characters",
  ],
  surnameRules: [
    (v) => !!v || "Surname is required",
    (v) => v.length <= 20 || "Surname must be at most 20 characters",
  ],
  companyNameRules: [
    (v) => v.length <= 100 || "Company name must be at most 100 characters",
  ],
  vatNumberRules: [
    (v) => !!v || "VAT number is required when the company name is specified",
    (v) => (new RegExp(/^[mM][tT]\d{8}$/)).test(v) || "VAT number must start with MT followed by 8 characters",
  ],
  streetNameRules: [
    (v) => !!v || "Street name is required",
    (v) => v.length <= 50 || "Street name must be at most 50 characters",
  ],
  houseNameNumberRules: [
    (v) => !!v || "House name / number is required",
    (v) => v.length <= 50 || "House name must be at most 50 characters",
  ],
  postCodeRules: [
    (v) => !!v || "Post Code is required",
    (v) => (new RegExp(/^[a-zA-Z]{3}\s?\d{4}$/)).test(v) || "Post Code must consist of 3 letters followed by 4 digits",
  ],
  localityRules: [(v) => !!v || "Locality is required"],
  noticeRules: [(v) => !!v || "Notification is required"],
  noticeDateRules: [(v) => !!v || "Notification date is required"],
  notificationFileRules: [
    (v) => !!v || "Copy of notification is required",
    (v) => !v || v.size <= 1.2e7 || "File size must be less than 12MB"
  ],
  notificationFileRulesTest (filePreloaded) {
    var rules = [];
    if (!filePreloaded){
      rules.push((v) => !!v || "Copy of notification is required");
    }

    rules.push((v) => !v || v.size <= 1.2e7 || "File size must be less than 12MB");
    
    return rules;
  },
  requiredTrackingNumberRules: [
    (v) => !!v || "Tracking Number is required",
    (v) => /^[a-zA-Z\d-]{1,30}$/.test(v) || 'Invalid Tracking Number'
  ],
  bulkyTrackingNumberRules: [
    (v) => /^[a-zA-Z\d-]{0,30}$/.test(v) || 'Tracking Number must be alpha numeric and not longer than 30 characters'
  ],
  optionalTrackingNumberRules: [
    (v) => !v || /^[a-zA-Z]{2}\d{9}[a-zA-Z]{2}$/.test(v) || 'Invalid Tracking Number'
  ],
  emailRules: [
    (v) => !!v || "Email is required",
    (v) =>
      !v ||
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) ||
      "E-mail is not valid",
    (v) => v.length <= 50 || "Email must be at most 50 characters"
  ],
  hscodeRules: [
    (v) => !!v || "HS Code is required",
    (v) => !v || (new RegExp(/^[0-9]{6}([0-9]{2}){0,2}$/)).test(v) || "HS Code must be 6, 8 or 10 digits. Alphabetic Prefixes are not supported."
  ],
  countryOfOriginRules: [
    (v) => !!v || "Country of Origin is required"
  ],
  phoneRules: [
    (v) => !!v || "Phone Number is required",
    (v) => !v || v.length <= 20 || "Phone number must be at most 20 digits.",
    (v) => (new RegExp(/^[0-9]*$/)).test(v) || "Phone number must contain only digits"
  ],
  dialingCodeRules: [
    (v) => !!v || "Country dialing code is required"
  ],
  vatNumberSenderRules: [
    (v) => v.length <= 10 || "VAT number must be at most 10 characters"
  ],
  vatNumberRecipientRules: [
    (v) => v.length <= 20 || "VAT number must be at most 20 characters"
  ],
  parcelLockerRules: [
    (v) => !!v || "Parcel Locker is required"
  ],
  postOfficeRules: [
    (v) => !!v || "Post Office is required"
  ],
  easipikCustomerCodeRules: [
    (v) => !!v || "Easipik customer code is required",
    (v) => !v || /^[a-zA-Z]{2}(\d{4}|[a-zA-Z]{3})[a-zA-Z]{2}$/.test(v) || 'Invalid Easipik Customer Code'
  ]
};